export const mockData = {
  profile: {
    name: "Faizan Yousaf",
    title: "Full-Stack Developer & AI Engineer",
    location: "Faisalabad, Pakistan",
    email: "faizanyousaf140@gmail.com",
    phone: "(+92) 345-7956200, (+92) 300-6659200",
    linkedin: "https://www.linkedin.com/in/faizan-yousaf1",
    github: "https://github.com/Faizanyousaf140",
    summary:
      "Computer Science student with experience in full-stack web development using React, Next.js, Node.js and Django. Built AI-assisted features using NLP, Generative AI, and Retrieval-Augmented Generation (RAG). Comfortable working with REST and FastAPI services and SQL/NoSQL databases. Interested in building practical applications that combine AI with modern web systems.",
    profileImage: "",
    profileImage: "/assets/faizan.jpeg",
    cvUrl: "/assets/MUHAMMAD FAIZAN YOUSAF CV.pdf",
  },
  skills: {
    frontend: [
      { name: "React. js", level: 90, category: "Frontend" },
      { name: "Next.js", level: 85, category: "Frontend" },
      { name: "JavaScript (ES6+)", level: 92, category: "Frontend" },
      { name: "Tailwind CSS", level: 90, category: "Frontend" },
      { name: "ShadCN UI", level: 85, category: "Frontend" },
      { name: "HTML5/CSS3", level: 95, category: "Frontend" },
    ],
    backend: [
      { name: "Node. js", level: 90, category: "Backend" },
      { name: "Express.js", level: 88, category: "Backend" },
      { name: "MongoDB", level: 85, category: "Backend" },
      { name: "MySQL", level: 80, category: "Backend" },
      { name: "RESTful APIs", level: 92, category: "Backend" },
      { name: "Python", level: 85, category: "Backend" },
    ],
    ai_ml: [
      { name: "AI Agents", level: 85, category: "AI/ML" },
      { name: "Workflow Automation", level: 70, category: "AI/ML" },
      { name: "NLP", level: 78, category: "AI/ML" },
      { name: "Machine Learning", level: 90, category: "AI/ML" },
      { name: "Deep Learning", level: 90, category: "AI/ML" },
      { name: "Generative AI", level: 85, category: "AI/ML" },
    ],
    tools: [
      { name: "Github", level: 90, category: "Tools" },
      { name: "Docker", level: 60, category: "Tools" },
      { name: "VS Code", level: 95, category: "Tools" },
      { name: "Postman", level: 85, category: "Tools" },
      { name: "Linux", level: 80, category: "Tools" },
      {name: "Git", level: 80, category: "Tools" },
  ],
  },
  projects: [
    {
      id: 1,
      title: "HealthMate (Final Year Project)",
      description:
        "Cross-platform mobile health application enabling users to submit lifestyle data, health metrics, and genetic SNP questionnaire responses.",
      technologies: ["Flutter", "Dart", "Firebase", "Firestore"],
      status: "In Progress",
      type: "Mobile App",
      date: "2024 - 2026",
      github: "https://github.com/Faizanyousaf140",
      live: null,
      image: "/assets/healthMate.png",
      features: [
        "Cross-platform Flutter app",
        "Secure authentication and real-time data storage",
        "Wearable device integration for continuous monitoring",
      ],
    },
    {
      id: 2,
      title: "AI Knowledge OS",
      description:
        "Full-stack application for managing project notes and documentation with semantic search using RAG and vector embeddings.",
      technologies: ["Next.js", "React", "Node.js", "Express.js", "MongoDB", "RAG", "NLP"],
      status: "Completed",
      type: "Web Application",
      date: "2024 - 2025",
      github: "https://github.com/Faizanyousaf140/",
      live: null,
      image: "/assets/AI Knowledge OS.png",
      features: [
        "Semantic search with vector embeddings",
        "JWT-based authentication",
        "AI chat interface for summarization and retrieval",
      ],
    },
    {
      id: 3,
      title: "RAG for diagnostic reasoning for Clinical Notes",
      description:
        "Retrieval-Augmented Generation (RAG) based clinical Q&A system using the MIMIC-IV dataset and LLMs.",
      technologies: ["NLP", "Python", "Vector database", "MIMIC-IV"],
      status: "Completed",
      type: "AI Research",
      date: "2024 - 2025",
      github: "http://github.com/Faizanyousaf140/RAG-for-Diagnostic-Reasoning-in-Clinical-Notes-DiReCT-",
      live: null,
      image: "/assets/RAG.png",
      features: [
        "Context-aware medical assistant",
        "Semantic retrieval from clinical records",
      ],
    },
    {
      id: 4,
      title: "VerbatimAI",
      description:
        "Meeting analysis system converting recorded meetings into structured insights using speech-to-text and NLP summarization.",
      technologies: ["Python", "NLP", "Streamlit", "Vector Embeddings"],
      status: "Completed",
      type: "AI Application",
      date: "2024",
      github: "https://github.com/Faizanyousaf140/Verbatim-AI-Project",
      live: null,
      image: "/assets/Live coding demo.png",
      features: [
        "Speech-to-text transcription",
        "NLP-based summarization",
      ],
    },
    {
      id: 5,
      title: "Neural-Machine-Translation-Urdu-to-Roman-Urdu",
      description: "BiLSTM encoder-decoder with Bahdanau attention specialized for poetic text.",
      technologies: ["PyTorch", "BiLSTM", "Bahdanau Attention"],
      status: "Completed",
      type: "Research",
      date: "2023",
      github: "https://github.com/Faizanyousaf140/Neural-Machine-Translation-Urdu-to-Roman-Urdu",
      live: "https://nmt-urdu-to-roman-urdu.streamlit.app/",
      image: "/assets/NMT urdu to roman urdu.png",
      features: ["Translation model trained on Rekhta Ghazals dataset"],
    },
    {
      id: 6,
      title: "Conversational-Chatbot-in-Urdu",
      description: "Transformer-based conversational chatbot with multiple decoding strategies.",
      technologies: ["Transformer", "PyTorch"],
      status: "Completed",
      type: "Research",
      date: "2023",
      github: "https://github.com/Faizanyousaf140/Conversational-Chatbot-in-Urdu",
      live: "https://conversational-urdu-chatbot.streamlit.app/",
      image: "/assets/Conversational chatbot.png",
      features: ["Supports Greedy, Beam Search, Top-k decoding"],
    },
  ],
  experience: [
    {
      id: 1,
      position: "Intern (Onsite)",
      company: "Digital Genei",
      duration: "June 2025 - July 2025",
      type: "Internship",
      description:
        "Developed a speech-to-text pipeline using Whisper for meeting transcription and applied NLP summarization to extract key discussion points.",
      companyUrl: "https://www.linkedin.com/company/digitalgenei/posts/?feedView=all",
      achievements: [
        "Implemented speech-to-text transcription pipeline using Whisper",
        "Added NLP summarization to extract meeting highlights",
        "Implemented semantic search using FAISS for vector indexing",
      ],
      technologies: ["Whisper", "Python", "NLP", "FAISS"],
      image: "/assets/digitalgenei_logo.jpg",
    },
    {
      id: 2,
      position: "Intern (Remote)",
      company: "Skillify Zone",
      duration: "July 2025 - August 2025",
      type: "Internship",
      description:
        "Built a loan approval prediction system using Pandas and Scikit-learn with structured dataset preprocessing and feature engineering.",
      companyUrl: "https://www.linkedin.com/company/skillifyzone/",
      achievements: [
        "Built loan approval prediction model with Pandas and scikit-learn",
        "Performed feature engineering and model evaluation to improve accuracy",
      ],
      technologies: ["Pandas", "Scikit-learn", "Python", "Feature Engineering"],
      image: "/assets/skillifyzone_logo.jpg",
    },
  ],
  teachingAssistantships: [
    {
      id: 1,
      role: "Teaching Assistant (Computer Networks Lab)",
      institution: "FAST - NUCES CFD Campus",
      duration: "January 2025 - June 2025",
      status: "Completed",
      studentsAssisted: 40,
      tasks: [
        "Assisted in preparing and delivering 15 lab tutorials",
        "Supported 1 lab project and helped students with quizzes and CP work",
      ],
      topics: ["Packet Analysis", "Network Simulation", "Socket Programming", "Routing Labs"],
      assessments: {
        quizzes: 2,
      },
    },
    {
      id: 2,
      role: "Teaching Assistant (Computer Networks)",
      institution: "FAST - NUCES CFD Campus",
      duration: "August 2025 - January 2026",
      status: "Completed",
      studentsAssisted: 50,
      tasks: [
        "Designed and assisted with assignment and quiz preparation",
        "Conducted support sessions and clarified networking concepts",
      ],
      topics: [
        "OSI Model",
        "TCP/IP",
        "Routing",
        "Subnetting",
        "Transport Protocols",
      ],
      assessments: {
        quizzes: 7,
        assignments: 5,
        cps: 4,
      },
    },
    {
      id: 3,
      role: "Teaching Assistant (Design and Analysis of Algorithms)",
      institution: "FAST - NUCES CFD Campus",
      duration: "August 2025 - January 2026",
      status: "Completed",
      studentsAssisted: 40,
      tasks: [
        "Assisted in quiz and assignment design",
        "Supported students in complexity analysis and problem-solving strategies",
      ],
      topics: [
        "Divide and Conquer",
        "Greedy Algorithms",
        "Dynamic Programming",
        "Graph Algorithms",
        "Time and Space Complexity",
      ],
      assessments: {
        quizzes: 6,
        assignments: 6,
      },
    },
    {
      id: 4,
      role: "Teaching Assistant (Web Programming)",
      institution: "FAST - NUCES CFD Campus",
      duration: "January 2026 - June 2026",
      status: "In Progress",
      studentsAssisted: 45,
      tasks: [
        "Assisting labs and practical sessions for frontend and backend topics",
        "Guiding students on assignments and mini-project implementations",
      ],
      topics: ["HTML", "CSS", "JavaScript", "React", "REST APIs","MERN Stack Development"],
      assessments: {
        quizzes: 6,
        assignments: 6,
        cps: 5,
      },
    },
  ],
  education: [
    {
      degree: "Bachelor of Computer Science",
      institution: "FAST - NUCES CFD Campus",
      duration: "2022 - 2026",
      status: "In Progress",
      cgpa: "3.30",
      details: "Final-year Computer Science student with a focus on software development and AI applications. Relevant coursework includes Data Structures, Algorithms, Database Systems, Machine Learning, and Software Engineering Principles.",
    },
    {
      degree: "FSc (Pre-Engineering)",
      institution: "BISE Faisalabad",
      duration: "2020 - 2022",
      grade: "A+",
    },
    {
      degree: "Matriculation (Science)",
      institution: "BISE Faisalabad",
      duration: "2018 - 2020",
      grade: "A+",
    },
  ],
  certifications: [
    {
      name: "Coursera – Machine Learning Specialization",
      issuer: "Coursera",
      date: "2024",
      file: "/assets/machine learning specilization.jpg",
    },
  ],
  activities: [
    {
      id: 1,
      title: "Co-Head Registrations (Daira)",
      organization: "Daira 2024",
      duration: "2024",
      details: "Managed registration processes and coordinated volunteers for event operations.",
    },
    {
      id: 2,
      title: "YDPC Management Head",
      organization: "Young Peace and Development Corps",
      duration: "2026",
      details: "Participated in community development initiatives and led local outreach programs.",
    },
  ],
};
